<section class="panel widget-container">
  <header class="panel-heading">
    <h5 class="panel-title">Users</h5>
  </header>
  <i type="button" pButton (click)="navigate()" icon="fa-fw fa fa-user"></i>
</section>
